import {Component} from "react";
import React from "react";
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";
import './Search.css';
import connect from "react-redux/es/connect/connect";
import {fetchSearchData} from "../../actions/searchActions";
import Accordion from "../Shared/Accordion";

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerms: []
        };
        this.closeModal = this.closeModal.bind(this);
        // this.getSearchOptions = this.getSearchOptions.bind(this);
    }

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal(false, 'search')
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
        this.props.dispatch(fetchSearchData());
        let searchTermsList = [...this.props.searchObject];
        let searchList = ['Search By Device', 'Search By Demo Type', 'Creative Type', 'Vertical', 'Subcategory', 'Functionality', 'Additional Features'];
        let sortedTerm = ['Device', 'Demo Type', 'Mock Or Live Units', 'Vertical', 'Functionality', 'Subcategory', 'Additional Features'];

        let newSearchList = false;
        const myArrayFiltered = searchTermsList.filter((elem) => {
            return newSearchList = searchList.find((k) => {
                if(elem.title === k){
                    if(elem.title === "Creative Type"){
                        elem.title = "Mock Or Live Units"
                    }
                    if(elem.title === "Search By Device"){
                        elem.title = "Device"
                    }
                    if(elem.title === "Search By Demo Type"){
                        elem.title = "Demo Type"
                    }
                    return elem
                }
            })
        });

       let sorted = myArrayFiltered.sort((a,b) => {
            return sortedTerm.indexOf(a.title) - sortedTerm.indexOf(b.title);
        })
        this.setState({searchTerms : sorted})
        // $("html, body").animate({ scrollTop: 0 }, 300);
    }


    render() {

        return (
            <React.Fragment>
                <div className="modal-overlay">
                <section className="search-modal modal modal--unit">
                    <div className="modal-content">
                        <div onClick={() => this.props.toggleModal(false, 'search')} className="closeBtn">
                            <SVG src={closeicon}/>
                        </div>

                        <div className="modal-header">
                            <h1>Available Search Terms</h1>
                        </div>
                        <div className="modal-search-section">
                            <div className="modal-search-section-header">
                                Brand, Campaign, Seller, or Designer
                            </div>
                            <Accordion data={this.state.searchTerms} closeModal={this.props.toggleModal} />
                        </div>
                    </div>
                </section>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    searchObject: state.search.searchObject,
});

export default connect(mapStateToProps)(Search);
